import React from "react";
import { Tooltip } from "reactstrap";

class TooltipItemText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };
  }
  toggle = () => {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
  };

  render() {
    return (
      <span className={this.props.className?this.props.className:""}>
        <span id={"Tooltip-" + this.props.id} className={this.props.item.className?this.props.item.className:""} >
          {this.props.item.text}
        </span>
        <Tooltip
          placement={this.props.item.placement}
          isOpen={this.state.tooltipOpen}
          target={"Tooltip-" + this.props.id}
          toggle={this.toggle}
        >
          {this.props.item.body}
        </Tooltip>
      </span>
    );
  }
}
export default TooltipItemText;
